/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sovereign_Anti_FraudInputs */

const en_sovereign_anti_fraud = /** @type {(inputs: Sovereign_Anti_FraudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anti-fraud transaction layer`)
};

const id_sovereign_anti_fraud = /** @type {(inputs: Sovereign_Anti_FraudInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lapisan transaksi anti-penipuan`)
};

/** @type {(inputs: Sovereign_Anti_FraudInputs) => LocalizedString} */
const es_sovereign_anti_fraud = en_sovereign_anti_fraud;

/** @type {(inputs: Sovereign_Anti_FraudInputs) => LocalizedString} */
const fr_sovereign_anti_fraud = en_sovereign_anti_fraud;

/** @type {(inputs: Sovereign_Anti_FraudInputs) => LocalizedString} */
const de_sovereign_anti_fraud = en_sovereign_anti_fraud;

/** @type {(inputs: Sovereign_Anti_FraudInputs) => LocalizedString} */
const ja_sovereign_anti_fraud = en_sovereign_anti_fraud;

/** @type {(inputs: Sovereign_Anti_FraudInputs) => LocalizedString} */
const zh_sovereign_anti_fraud = en_sovereign_anti_fraud;

/** @type {(inputs: Sovereign_Anti_FraudInputs) => LocalizedString} */
const ar_sovereign_anti_fraud = en_sovereign_anti_fraud;

/** @type {(inputs: Sovereign_Anti_FraudInputs) => LocalizedString} */
const it_sovereign_anti_fraud = en_sovereign_anti_fraud;

/** @type {(inputs: Sovereign_Anti_FraudInputs) => LocalizedString} */
const ru_sovereign_anti_fraud = en_sovereign_anti_fraud;

/** @type {(inputs: Sovereign_Anti_FraudInputs) => LocalizedString} */
const pt_sovereign_anti_fraud = en_sovereign_anti_fraud;

/** @type {(inputs: Sovereign_Anti_FraudInputs) => LocalizedString} */
const ko_sovereign_anti_fraud = en_sovereign_anti_fraud;

/**
* | output |
* | --- |
* | "Anti-fraud transaction layer" |
*
* @param {Sovereign_Anti_FraudInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const sovereign_anti_fraud = /** @type {((inputs?: Sovereign_Anti_FraudInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sovereign_Anti_FraudInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sovereign_anti_fraud(inputs)
	if (locale === "es") return es_sovereign_anti_fraud(inputs)
	if (locale === "fr") return fr_sovereign_anti_fraud(inputs)
	if (locale === "de") return de_sovereign_anti_fraud(inputs)
	if (locale === "ja") return ja_sovereign_anti_fraud(inputs)
	if (locale === "zh") return zh_sovereign_anti_fraud(inputs)
	if (locale === "ar") return ar_sovereign_anti_fraud(inputs)
	if (locale === "id") return id_sovereign_anti_fraud(inputs)
	if (locale === "it") return it_sovereign_anti_fraud(inputs)
	if (locale === "ru") return ru_sovereign_anti_fraud(inputs)
	if (locale === "pt") return pt_sovereign_anti_fraud(inputs)
	return ko_sovereign_anti_fraud(inputs)
});